module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-03-099ef2035759b3f2784213c7892eb83d.jpg";